<invoice-cash-desk-view (onClose)="close()" [appointmentId]="appointmentId" [invoiceId] ="invoiceId"></invoice-cash-desk-view>
